import { Injectable } from '@angular/core';
import { BcpCrypto, BcpDecryptConfig, BcpEncryptConfig } from '@bcp/js-crypto';

@Injectable()
export class CryptoService {
  private pwdCrypto = '';
  private iv = '';

  constructor(
    private crypto: BcpCrypto,
  ) { }

  setCredentials(password: string, iv: string) {
    this.pwdCrypto = password;
    this.iv = iv;
  }

  encrypt(data: any) {
    const encryptConfig: BcpEncryptConfig = {
      password: this.pwdCrypto,
      iv: this.iv,
      text: JSON.stringify(data),
    };

    return this.crypto.encrypt(encryptConfig);
  }

  encrypt256(data: any){
    return this.crypto.createHashSHA(data, 256);
  }

  convertToUTF8(input: string): string {
    return encodeURIComponent(input);
  }

  decrypt(cipheredValue: string) {
    const decryptConfig: BcpDecryptConfig = {
      cipheredValue,
      password: this.pwdCrypto,
      iv: this.iv,
    };

    return JSON.parse(this.crypto.decrypt(decryptConfig));
  }

  base64URLEncode(input: string): string {
    const base64 = btoa(input);
    const base64url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return base64url;
  }
 
}
